import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div className="px-4 pb-10 pt-8 sm:px-6 md:pt-12">
      <section>
        <div className="mx-auto w-full max-w-5xl">
          <p className="section-kicker">
            Privacy Policy
          </p>
          <h1 className="mt-4 text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            Vizo is designed to keep music files and creative work primarily on your device.
          </h1>
          <p className="mt-4 text-base leading-8 text-slate-300">Last updated: May 30, 2026</p>
        </div>
      </section>

      <section className="py-10">
        <div className="mx-auto grid w-full max-w-6xl gap-4 lg:grid-cols-2">
          <article className="glass-panel rounded-[28px] p-6">
            <h2 className="text-2xl font-semibold text-white">What Vizo uses</h2>
            <p className="mt-3 text-sm leading-7 text-slate-300">
              Vizo uses audio files, artwork, templates, presets, and export settings to generate music visualizations inside the app.
              Most of this processing happens locally on your iPhone.
            </p>
            <ul className="mt-4 space-y-2 text-sm leading-7 text-slate-300">
              <li>Imported audio and images are used to render visuals you create.</li>
              <li>Export preferences are stored locally so your workflow stays consistent.</li>
              <li>Subscription status is handled through Apple and StoreKit.</li>
            </ul>
          </article>

          <article className="glass-panel rounded-[28px] p-6">
            <h2 className="text-2xl font-semibold text-white">What we do not store</h2>
            <p className="mt-3 text-sm leading-7 text-slate-300">
              We do not run a cloud media library for your imported songs, exported videos, or preset artwork through this website.
            </p>
            <ul className="mt-4 space-y-2 text-sm leading-7 text-slate-300">
              <li>No payment card data is stored by us.</li>
              <li>No uploaded audio library is maintained by this site.</li>
              <li>Your App Store purchase flow remains under Apple systems.</li>
            </ul>
          </article>

          <article className="glass-panel rounded-[28px] p-6">
            <h2 className="text-2xl font-semibold text-white">Diagnostics and support</h2>
            <p className="mt-3 text-sm leading-7 text-slate-300">
              If you contact support, you may choose to share screenshots, device details, app version information, or issue descriptions so we can troubleshoot.
            </p>
            <ul className="mt-4 space-y-2 text-sm leading-7 text-slate-300">
              <li>Support emails are used only to respond to your request.</li>
              <li>Crash or diagnostic data may be provided through Apple platforms, subject to Apple settings.</li>
              <li>You can stop sharing new support information at any time.</li>
            </ul>
          </article>

          <article className="glass-panel rounded-[28px] p-6">
            <h2 className="text-2xl font-semibold text-white">Your choices</h2>
            <ul className="mt-4 space-y-2 text-sm leading-7 text-slate-300">
              <li>Delete local app data by removing the app from your device.</li>
              <li>Manage subscriptions from your Apple ID subscription settings.</li>
              <li>Contact support if you need clarification about data use.</li>
            </ul>
          </article>

          <article className="glass-panel rounded-[28px] p-6 lg:col-span-2">
            <h2 className="text-2xl font-semibold text-white">Contact</h2>
            <p className="mt-3 text-sm leading-7 text-slate-300">
              Questions about privacy or support can be sent to the addresses below.
            </p>
            <ul className="mt-4 space-y-2 text-sm leading-7 text-slate-300">
              <li>Email: privacy@vizoapp.com</li>
              <li>Support: support@vizoapp.com</li>
              <li>
                Terms:{' '}
                <a
                  href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition hover:text-white"
                >
                  Apple Standard EULA
                </a>
              </li>
            </ul>
          </article>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
